<script setup>
import { onMounted, ref, watch, defineProps } from 'vue';
import i18n from "@/i18n"
import { showMessage } from "@/utils/hooks/message"
import { getFileUrl } from "@/service"
import { gethscodeByTemplate } from "@/service/apiList/productLine"
import { getDashboardCertification_body } from "@/service/apiList/dashboard"
import usetablePageNation from "@/utils/hooks/usetablePageNation" //分页hooks
import PreviewImg from "@/components/common/PreviewImg";
import { useRoute } from 'vue-router';
import { getLangValue, makeQrCode } from "@/utils/common"; //获取后端语言
const props = defineProps({
    category_id: {
        type: Number,
        required: true,
        default: 3   // 质量 3  碳足迹 5
    }
})
const route = useRoute();
const activeImageSrc = ref('')
const showPreviewImg = ref(false)
const tableInfo = ref([])
const typeList = ref([])
const fileList = ref([])
const table_head = ref([
    { name: 'NO.', width: '2%', checked: true },
    { name: getLangValue("business-user.testingOrganization"), width: '10%', key: 'company_name', checked: true }, //检测机构
    { name: getLangValue('hscode.indicatorName'), width: '8%', key: 'name', url: '', checked: true }, //指标名称
    { name: getLangValue("attribute.reference"), width: '10%', key: 'reference', checked: true }, //参考标准 
    // { name: 'OID', width: '8%', key: 'oid', url: '', checked: true }, //OID
    { name: getLangValue("dashboard.quality.tableHeader9"), width: '8%', key: 'code', url: 'code', checked: true, show: true }, //检测机构二维码
    { name: getLangValue("product-template.testinginstitutions1"), width: '8%', key: 'company_qualification_certification_body', checked: true, show: true }, //检测机构资质认证机构
    { name: getLangValue("dashboard.quality.tableHeader10"), width: '8%', key: 'price', checked: true, show: true }, //检测价格（$）
    { name: getLangValue("dashboard.quality.tableHeader11"), width: '8%', key: 'cycle', checked: true, show: true }, //检测周期（天）
    { name: getLangValue("dashboard.quality.form_contacts"), width: '8%', key: 'contact_name', checked: true, show: true }, //联系人
    { name: getLangValue("dashboard.quality.mobile"), width: '8%', key: 'mobile_phone_number', checked: true, show: true }, //联系电话
    { name: getLangValue("dashboard.quality.tableHeader13"), width: '8%', key: 'contact_email', checked: true, show: true },    //电子邮箱
    { name: getLangValue("dashboard.quality.tableHeader12"), width: '8%', key: 'company_website', checked: true, show: true },//公司链接
    { name: getLangValue("dashboard.quality.tableHeader14"), width: '8%', key: 'group_name', checked: true, show: true },//指标分组
])
const hscodeList = ref([])
const pageSizeOption = [10, 20, 30, 40, 50]
const loading = ref(false)
const { total, currentPage, pageSize, pageOption } = usetablePageNation(getDataList)
const type = ref('')
const hscode = ref('')
const keyword = ref('')
const getDataList = async () => {
    loading.value = true
    //获取数据
    let params = {
        page: currentPage.value - 1,
        limit: pageSize.value,
        // type: type.value,
        category_id: props.category_id, // 质量
        hscode_id: hscode.value,
        keyword: keyword.value.trim(),
    }
    if (!params.hscode_id) {
        showMessage('danger', getLangValue("dashboard.fillDataMessage1"))
        return
    }
    loading.value = true;
    const resp = await getDashboardCertification_body(params);
    loading.value = false;
    if (resp.code == 0) {
        tableInfo.value = resp.payload.data;
        tableInfo.value.forEach(async element => {
            if (element.testing_institution_user && element.testing_institution_user.oid) {
                const reps = await makeQrCode({ type: 1, id: element.testing_institution_user?.id })
                if (reps) {
                    element.code = reps
                }
            }
        });
        total.value = resp.payload.total
        if (resp.payload.data.length == 0) {
            showMessage('info', getLangValue('base.no_data'))
        }

        // setPages();
    }
}
const changeTemplate = (index = 1) => {
    //模板-目标市场切换
    if (index == 1)
        hscode.value = ''
    if (type.value.length) {
        let arr = typeList.value.filter(item => item.value === type.value[0] && item.children.filter(item1 => item1.value === type.value[1]).length)
        if (arr.length) {
            // 获取shcode
            let arr1 = arr[0].children.filter(item => item.value === type.value[1])
            if (arr1.length) {
                hscodeList.value = arr1[0].database_template_list.map(item => {
                    return {
                        id: item.hscode?.id,
                        title: item.hscode?.title,
                        title_en: item.hscode?.title_en,
                    }
                })
            }
        }
    } else {
        hscodeList.value = []
    }
}

const search = () => {
    //搜索
    currentPage.value = 1;
    getDataList()
}

const getIndicatorCategory = async () => {
    // 获取模板-目标市场
    loading.value = true;
    const resp = await gethscodeByTemplate();
    loading.value = false;
    if (resp) {
        typeList.value = resp.payload.filter(item => item.destination_market_list.length).map(item => {
            return {
                label: item.name,
                label_en: item.name_en,
                value: item.name,
                children: item.destination_market_list.map(item1 => {
                    return {
                        label: item1.title,
                        label_en: item1.title_en,
                        value: item1.id,
                        database_template_list: item1.database_template_list
                    }
                })
            }
        })
        type.value = route.query.product_template_name
        hscode.value = route.query.hscode
        keyword.value = route.query.keyword
        changeTemplate(0)
        getDataList();
    }
}


const showImageCode = (url) => {
    /**查看二维码大图 */
    activeImageSrc.value = url;
    if (activeImageSrc.value == "") {
        return;
    }
    showPreviewImg.value = true;
}

const formatterUrl = (url) => {
    // 公司链接格式化
    // 如果包含了http || https 则认为是完整链接 否则加上http
    if (!/^(?:https?|http):\/\//i.test(url)) {
        url = 'http://' + url;
    }
    return url;
}


onMounted(() => {
    // getDataList();
    getIndicatorCategory();
    // getHscodeList();
})

watch(pageSize, () => {
    currentPage.value = 1;
    getDataList();
})

watch(currentPage, () => {
    getDataList();
})

watch(tableInfo, () => {
    fileList.value = []
    let imageList = tableInfo.value.filter(item => item['picture']).map((item) => item['picture'][0])
    // 重复图片 去重
    imageList = [...new Set(imageList)]
    let imgStr = imageList.join(',')
    if (imgStr)
        getFileUrl({ attachments: imgStr }).then(resp => {
            if (resp) {
                fileList.value = resp.payload
            }
        })

},)

</script>
<template>
    <div class="qualitySearchTable11 px-3 py-2 " style="height: calc(100% - 1rem) " v-loading="loading">
        <div class="d-flex justify-content-between align-items-center">
            <div class="search d-flex align-items-center">
                <el-cascader style="width: 280px; height: 38px;" v-model="type" :options="typeList"
                    :placeholder="getLangValue('dashboard.dataBaseType')" :props="{label: i18n.global.locale == 'en' ?'label_en': 'label',}" @change="changeTemplate(1)" />

                <el-select v-model="hscode" filterable clearable class="mx-2" placeholder="HS Code"
                    style="max-width: 280px; height: 38px;">
                    <el-option v-for="item in hscodeList" :key="item.value" :label=" i18n.global.locale == 'en'? item.title_en : item.title"  :value="item.id" />
                </el-select>
                <div class="form-icon" style="max-width: 360px;flex: 1;">
                    <input style="width: 100%;" clearable class="form-control form-control-icon" v-model="keyword"
                        required :placeholder="getLangValue('dashboard.input3_1')" />
                    <i class="ri-search-line"></i>
                </div>
            </div>
            <div class="d-flex">
                <div class="d-flex" style="color: white;">
                    <!-- <button id="btnGroupVerticalDrop1" type="button" class="btn dropdown-toggle"
                        data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                        style="padding: 0 3px; color: white;">
                        <i class="ri-filter-line"></i>{{ getChecked() }}{{ getLangValue('dashboard.quality.selectLegnth') }}
                    </button>
                    <div class="dropdown-menu " aria-labelledby="btnGroupVerticalDrop1">
                        <template v-for="(hItem) in table_head" :key="hItem">
                            <div class="m-2 d-flex align-items-center">
                                <input class="form-check-input mt-0 mx-2" type="checkbox" v-model="hItem.checked"
                                    aria-label="Checkbox for following text input">
                                <span>{{ hItem.name }}</span>
                            </div>
                        </template>
</div> -->
                </div>
                <button type="button" class="btn btn-success mx-3" @click="search()" style="min-width: 93px;">
                    {{ getLangValue("base.search") }}
                </button>
            </div>
        </div>
        <div style="flex-direction: column; height: calc(100% - 40px);">
            <div class="my-table my-2" id="my-table">
                <!-- 表格信息 -->
                <div style="height:calc(100% - 60px - 1rem); overflow-y: auto;" class="my-scroll-bar">
                    <table class="table table-nowrap ">
                        <!-- table-nowrap -->
                        <thead class="table-light">
                            <tr>
                                <template v-for="(head, index) in table_head.filter(item => item.checked)" :key="index">
                                    <th v-if="head.key == 'reference'" scope="col"
                                        style="color: #212529;min-width: 200px">
                                        <div class="d-flex align-items-center">{{ head.name }}</div>
                                    </th>
                                    <th v-else scope="col" :key="index"
                                        style="color: #212529; min-width: 80px; word-break: keep-word; white-space: normal; max-width: 120px;"
                                        :width="head.width">
                                        <div :class="i18n.global.locale == 'en' ? 'en-word-break' : 'zh-word-break'"
                                            class="d-flex align-items-center">{{ head.name }}</div>
                                    </th>
                                </template>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(info, index) in tableInfo" :key="index" style="vertical-align: middle">
                                <td v-for="(item, kk) in table_head.filter(item => item.checked)" :key="kk"
                                    style="word-wrap: break-word; white-space: normal; max-width: 200px;">
                                    <span v-if="item.key == 'picture' || item.key == 'code'" class="cursor-pointer">
                                        <template
                                            v-if="info.testing_institution_user && info.testing_institution_user.oid">
                                            <img :src="info[item.url]" class="cursor-pointer"
                                                :title="info.testing_institution_user && info.testing_institution_user.oid"
                                                style="width: 48px;height: 48px;"
                                                @click="showImageCode(info[item.url])" />
                                        </template>
                                    </span>
                                    <template v-else-if="
                                        item.key == 'contact_name' ||
                                        item.key == 'mobile_phone_number' ||
                                        item.key == 'contact_email' ||
                                        item.key == 'company_website' ||
                                        item.key == 'company_qualification_certification_body'
                                    " class="cursor-pointer">
                                        <span v-if="info.testing_institution_user">
                                            <span v-if="item.key == 'contact_name'">
                                                {{ info.testing_institution_user.contact_first_name +
                                                    info.testing_institution_user.contact_last_name }}
                                            </span>
                                            <span v-else-if="item.key == 'company_website'">
                                                <a :href="formatterUrl(info.testing_institution_user[item.key])"
                                                    target="_blank"
                                                    style="color:#6691e7; text-decoration: underline !important;">{{
                                                        info.testing_institution_user[item.key] }}</a>
                                            </span>
                                            <span v-else>{{ info.testing_institution_user[item.key] }}</span>
                                        </span>

                                    </template>
                                    <!-- index_standard_test_price -->
                                    <template v-else-if="item.key == 'company_name'" class="cursor-pointer">
                                        <!-- <span v-if="info.organization && info.organization[item.key]">{{
                                            info.organization[item.key] }}</span> -->
                                        <span> {{ info.testing_institution }}</span>
                                    </template>
                                    <template v-else-if="item.key == 'name' || item.key == 'group_name'"
                                        class="cursor-pointer">
                                        <span v-if="info.index_standard">{{ i18n.global.locale == 'en'? info.index_standard[`${item.key}_en`]:  info.index_standard[item.key] }}</span>
                                    </template>

                                    <template v-else-if="item.key == 'price' || item.key == 'cycle'"
                                        class="cursor-pointer">
                                        <span v-if="info.index_standard_test_price">{{
                                            info.index_standard_test_price[item.key] }}</span>
                                    </template>

                                    <div v-else-if="item.key == 'reference'"
                                     :title="i18n.global.locale == 'en'?   info.index_standard?.reference_en : info.index_standard?.reference"
                                        style="width: 200px; max-height: 60px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                        <span v-if="info.index_standard">{{ i18n.global.locale == 'en'?   info.index_standard?.reference_en : info.index_standard?.reference }}</span>
                                    </div>
                                    <span v-else>{{ kk == 0 ? index + 1 : info[item.key] }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- 分页 -->
                <Pagination v-if="total" v-model:page="currentPage" v-model:perPage="pageSize" :pages="pageOption"
                    :prePageOption="pageSizeOption" :tab_info_length="total" class="me-5 my-3 my-pagination">
                </Pagination>
            </div>
        </div>
        <PreviewImg v-model:showPreviewImg="showPreviewImg" :src="activeImageSrc" :myWidth="400" v-if="showPreviewImg">
        </PreviewImg>
    </div>

</template>
<style scoped lang="scss">
.qualitySearchTable1 {
    .search {
        flex: 1;
        height: 38px;

        :deep(.el-input--suffix) {
            // width: 110px;
            height: 100%;
        }

        :deep(.el-select__wrapper) {
            background-color: #4a5056;
            height: 100%;
        }

        :deep(.el-input__wrapper) {
            background-color: #4a5056;
        }

        :deep(.el-select__placeholder.is-transparent) {
            color: #889AA5 !important;
        }

        :deep(.el-select__selected-item) {
            color: white;
        }


        :deep(.el-input__inner) {
            color: white;
        }

        .form-icon {
            display: inline-block;

            i {
                color: white
            }
        }

        .form-control {
            background-color: #4a5056;
            color: white;
            display: inline-block;
        }
    }

    .my-table {
        flex: 1; //way-2
        height: 100%; //way-2

        // max-height: 500px; // way-1
        table {
            color: white;
        }

        .my-pagination {
            color: white;

            :deep(.page_total) {
                color: white !important;
            }
        }
    }
}

.qualitySearchTable11 {
    .search {
        flex: 1;
        height: 38px;

        :deep(.el-input--suffix) {
            // width: 110px;
            height: 100%;
        }

        :deep(.el-select__wrapper) {
            // background-color: #4a5056;
            height: 100%;
        }

        :deep(.el-input__wrapper) {
            // background-color: #4a5056;
        }

        :deep(.el-select__placeholder.is-transparent) {
            font-size: 0.8125rem;
            color: #878a99 !important;
        }

        :deep(.el-cascader .el-input__inner) {
            &::placeholder {
                font-size: 0.8125rem;
                color: #878a99 !important;
            }
        }

        :deep(.el-select__selected-item.el-select__placeholder) {
            font-size: 0.8125rem;
            color: #212529;
        }
        :deep(.el-input__inner) {
            font-size: 0.8125rem;
            color: #212529;
        }

        .form-icon {
            display: inline-block;

            i {
                color: #212529
            }
        }

        .form-control {
            // background-color: #4a5056;
            color: #212529;
            display: inline-block;
        }
    }

    .my-table {
        flex: 1; //way-2
        height: 100%; //way-2

        // max-height: 500px; // way-1
        table {
            color: #212529;
        }

        .my-pagination {
            color: #212529;

            :deep(.page_total) {
                color: #212529 !important;
            }
        }
    }
}
</style>